import { CacheableState } from '@utils/cacheable-state';

export interface ClientsState {
  allClients: CacheableState<Array<any>>;
  createClient: CacheableState<Array<any>>;
  clientById: CacheableState<Array<any>>;
  removeClient: CacheableState<Array<any>>;
  removeMember: CacheableState<Array<any>>;
  memberById: CacheableState<Array<any>>;
  updateMember: CacheableState<Array<any>>;
  addMember: CacheableState<Array<any>>;
  updateClient: CacheableState<Array<any>>;
  pendingRequestByMember: CacheableState<Array<any>>;
  addMultipleMembers: CacheableState<Array<any>>;
  removeAndAssign: CacheableState<Array<any>>;
}

export function clientsInitialState(): ClientsState {
  return {
    allClients: initialDataSubState().allClients,
    createClient: initialDataSubState().createClient,
    clientById: initialDataSubState().clientById,
    removeClient: initialDataSubState().removeClient,
    removeMember: initialDataSubState().removeMember,
    memberById: initialDataSubState().memberById,
    updateMember: initialDataSubState().updateMember,
    addMember: initialDataSubState().addMember,
    updateClient: initialDataSubState().updateClient,
    pendingRequestByMember: initialDataSubState().pendingRequestByMember,
    addMultipleMembers: initialDataSubState().addMultipleMembers,
    removeAndAssign: initialDataSubState().removeAndAssign,
  };
}
export function initialDataSubState(): ClientsState {
  return {
    allClients: new CacheableState(),
    createClient: new CacheableState(),
    clientById: new CacheableState(),
    removeClient: new CacheableState(),
    removeMember: new CacheableState(),
    memberById: new CacheableState(),
    updateMember: new CacheableState(),
    addMember: new CacheableState(),
    updateClient: new CacheableState(),
    pendingRequestByMember: new CacheableState(),
    addMultipleMembers: new CacheableState(),
    removeAndAssign: new CacheableState(),
  };
}
